module.exports = __webpack_public_path__ + "static/media/profile-picture-1.4d26e151.jpg";